import React from 'react';
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  Typography,
} from '@mui/material';
import CloseButton from './Common/CloseButton';

const WorkflowFlowManageDialogs = ({
  renameOpen,
  renameValue,
  renameError,
  deleteOpen,
  selectedFlowName,
  onRenameClose,
  onRenameValueChange,
  onRenameSubmit,
  onDeleteClose,
  onDeleteSubmit,
  t,
}) => (
  <>
    <Dialog
      open={renameOpen}
      onClose={onRenameClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: 3, boxShadow: 10 } }}
    >
      <DialogTitle sx={{
        bgcolor: 'primary.main',
        color: 'white',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        pr: 1,
      }}>
        {t('workflow.rename_flow_dialog_title', 'Rename Flow')}
        <CloseButton
          ariaLabel="close"
          onClick={onRenameClose}
          sx={{ color: 'white' }}
        />
      </DialogTitle>
      <DialogContent sx={{ pt: 2 }}>
        <TextField
          fullWidth
          autoFocus
          size="small"
          margin="normal"
          label={t('workflow.automation_flow_name_label', 'Flow name')}
          value={renameValue}
          onChange={(event) => onRenameValueChange(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              event.preventDefault();
              onRenameSubmit();
            }
          }}
        />
        {renameError && (
          <Alert severity="error" sx={{ mt: 1 }}>
            {renameError}
          </Alert>
        )}
      </DialogContent>
      <DialogActions sx={{ p: 2, justifyContent: 'space-between' }}>
        <Button onClick={onRenameClose} variant="outlined">
          {t('common.cancel', 'Cancel')}
        </Button>
        <Button onClick={onRenameSubmit} variant="contained">
          {t('workflow.rename_flow', 'Rename')}
        </Button>
      </DialogActions>
    </Dialog>

    <Dialog
      open={deleteOpen}
      onClose={onDeleteClose}
      PaperProps={{ sx: { borderRadius: 3, boxShadow: 10 } }}
    >
      <DialogTitle sx={{
        bgcolor: 'error.main',
        color: 'white',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        pr: 1,
      }}>
        {t('workflow.delete_flow_dialog_title', 'Delete Flow')}
        <CloseButton
          ariaLabel="close"
          onClick={onDeleteClose}
          sx={{ color: 'white' }}
        />
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mt: 2 }}>
          <Typography variant="body1" fontWeight="bold" paragraph>
            {t('workflow.delete_flow_dialog_question', 'Are you sure you want to delete this flow?')}
          </Typography>
          <Typography variant="body2" paragraph color="text.secondary">
            {t('workflow.delete_flow_dialog_name', 'Flow: {{name}}', { name: selectedFlowName || '-' })}
          </Typography>
          <Typography variant="body2" paragraph>
            {t('workflow.delete_flow_confirm', 'Delete this flow? Actions inside will be moved to another flow.')}
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ p: 2, justifyContent: 'space-between' }}>
        <Button onClick={onDeleteClose} variant="outlined">
          {t('common.cancel', 'Cancel')}
        </Button>
        <Button onClick={onDeleteSubmit} variant="contained" color="error">
          {t('workflow.delete_flow', 'Delete')}
        </Button>
      </DialogActions>
    </Dialog>
  </>
);

export default WorkflowFlowManageDialogs;
